import type { OrganizationSelection } from '@socialgoodsoftware/components';

type RememberedOrganizationFields = Partial<OrganizationSelection>;

export const selectedOrgStorageKey = 'selectedOrganization';

export function ParseStoredSelection(raw: string | null): OrganizationSelection | null {
  let selection: OrganizationSelection | null = null;
  if (raw) {
    try {
      const parsed = JSON.parse(raw) as { name?: unknown; precedence?: unknown };
      if (typeof parsed.name === 'string' && parsed.name.length > 0) {
        let precedence = 0;
        if (typeof parsed.precedence === 'number' && Number.isFinite(parsed.precedence)) {
          precedence = parsed.precedence;
        }
        selection = {
          name: parsed.name,
          precedence: precedence,
        };
      }
    } catch {
      selection = null;
    }
  }
  return selection;
}

export function ReadRememberedOrganization(): RememberedOrganizationFields {
  let fields: RememberedOrganizationFields = {};
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      const parsed = ParseStoredSelection(window.localStorage.getItem(selectedOrgStorageKey));
      if (parsed !== null) {
        fields = {
          name: parsed.name,
          precedence: parsed.precedence,
        };
      }
    } catch {
      fields = {};
    }
  }
  return fields;
}
